import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useInventoryReport(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/inventories/report/export`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryReport;
